import React from 'react';
import { usePetSizes, usePricingServices } from '../../hooks/useAdminData';
import './Pricing.scss';

interface PricingService {
  id: string;
  name: string;
  prices: {
    small: number;
    medium: number;
    large: number;
    xlarge: number;
  };
}

const Pricing: React.FC = () => {
  const petSizes = usePetSizes();
  const pricingServices = usePricingServices();
  
  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <div className="pricing-header">
          <h2 className="pricing-title">
            SIMPLE <span className="highlight-text">PRICING</span>
          </h2>
          <p className="pricing-subtitle">
            Transparent pricing based on your pet's size. No hidden fees, no surprises.
          </p>
        </div>
        
        {/* Dogs Image */}
        <div className="pricing-image">
          <div className="image-placeholder">
          </div>
        </div>
        
        {/* Size Cards with Pricing */}
        <div className="size-cards">
          {petSizes.map((size) => (
            <div key={size.id} className={`size-card ${size.color}`}>
              <div className="size-header">
                <div className={`size-icon ${size.color}`}>
                  <span>{size.icon}</span>
                </div>
                <h3 className="size-name">{size.name}</h3>
                <p className="size-weight">{size.weight}</p>
              </div>
              
              <div className="size-pricing">
                {pricingServices.map((service: PricingService) => (
                  <div key={service.id} className="service-price">
                    <span className="service-name">{service.name}</span>
                    <div className="price-container">
                      <span className="price">${service.prices[size.id as keyof typeof service.prices]}</span>
                      <span className="start-at-text">(Starts at)</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="pricing-disclaimer">
          Prices vary according to weight, coat type, breed, and regular grooming schedule.
        </p>
        
      </div>
    </section>
  );
};

export default Pricing;
